import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useSyncedRef } from "../../../../misc/SyncedRef"; // globalSearchValue allows us to update the "search" portion of the URL immediately
// (e.g. when there are 2 calls to setQueryParam() within a single event handler)
let globalSearchValue = { current: "" };
export function useQueryParam(key, defaultValue, opts) {
    const loc = useLocation();
    const locRef = useSyncedRef(loc);
    globalSearchValue.current = loc.search;
    const search = new URLSearchParams(loc.search);
    const rawValue = search.get(key);
    const value = rawValue === null ? defaultValue : rawValue;
    const nav = useNavigate(); // replace the history entry instead of pushing a new one. Used for state that
    // changes frequently (e.g. per-keystroke filter text) where a new history entry
    // per change would flood the back button.
    const replace = opts === null || opts === void 0 ? void 0 : opts.replace;
    const [state, setState] = useState(value);
    useEffect(() => { setState(value); }, [value]);
    const update = useCallback(value => {
        const search = new URLSearchParams(globalSearchValue.current);
        if (value === null || value === defaultValue) {
            search.delete(key);
        }
        else {
            search.set(key, value);
        }
        let searchStr = search.toString();
        globalSearchValue.current = searchStr;
        if (searchStr)
            searchStr = "?" + searchStr; // update immediately to prevent delay in URL update that affects things like auto-open modals
        setState(value === null ? defaultValue : value);
        nav(locRef.current.pathname + searchStr, replace ? { replace: true } : undefined);
    }, [locRef, nav, defaultValue, key, replace]);
    return [state, update];
}
